import React, { useEffect, useState } from "react";
import "../MATHSDOCTOR/styles/MD_AddDeleteQn.css";
// Added Loading Import
import Loading from "../../Common/Loading";

interface Question {
  qnno: number;
  qncatg: string;
  qnfilename: string;
}

interface AvailableQuestion {
  filename: string;
  category: string;
}

const EC_AddDeleteQn: React.FC = () => {
  const [questions, setQuestions] = useState<Question[]>([]);
  const [availableQns, setAvailableQns] = useState<AvailableQuestion[]>([]);
  const [selectedQnNo, setSelectedQnNo] = useState<number | null>(null);
  const [selectedAddFile, setSelectedAddFile] = useState<string>("");
  const [errorMsg, setErrorMsg] = useState<string>("");
  const [noQnsMsg, setNoQnsMsg] = useState<string>("");
  const [loading, setLoading] = useState<boolean>(false);

  const queryParams = new URLSearchParams(window.location.search);
  const API_BASE = process.env.REACT_APP_DOCUMENT_LINK || 'https://staging.sysadmin.elearnoncloud.com/';
  
  document.body.style.backgroundColor="#fff"
  // Safe Params Extraction
  const params = {
    Country: queryParams.get("Country") ?? "",
    Yr: queryParams.get("Yr") ?? "0",
    Strand: queryParams.get("Strand") ?? "0",
    SubStrand: queryParams.get("SubStrand") ?? "0",
    Topic: queryParams.get("Topic") ?? "0",
    LessonCode: queryParams.get("LessonCode") ?? ""
  };

  useEffect(() => {
    loadQuestions();
  }, []);

  const loadQuestions = async () => {
    setLoading(true);
    try {
      const qs = new URLSearchParams(params).toString();
      const res = await fetch(`${API_BASE}api/ec/questions/?${qs}`);
      const data = await res.json();

      setQuestions(data.questions || []);
      const avail = data.available_qns || [];
      setAvailableQns(avail);

      if (avail.length === 0) {
        setNoQnsMsg("There are no questions to add");
        setSelectedAddFile("");
      } else {
        setNoQnsMsg("");
        setSelectedAddFile(avail[0].filename);
      }
      setErrorMsg("");
    } catch {
      setErrorMsg("Failed to load questions");
    } finally {
      setLoading(false);
    }
  };

  const handleAdd = async () => {
    if (!selectedAddFile) return;

    const selected = availableQns.find(q => q.filename === selectedAddFile);
    if (!selected) return;
    
    setLoading(true);
    try {
      await fetch(`${API_BASE}api/ec/questions/add/`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          ...params,
          qn_filename: selected.filename,
          qn_category: selected.category
        })
      });
      await loadQuestions(); // loadQuestions handles setLoading(false)
    } catch {
      setErrorMsg("Error adding question");
      setLoading(false);
    }
  };

  const handleDelete = async () => {
    if (selectedQnNo === null) {
      alert("Please select a question");
      return;
    }

    if (!window.confirm("Do you really want to delete the selected Question?")) return;

    setLoading(true);
    try {
      await fetch(`${API_BASE}api/ec/questions/delete/`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          ...params,
          QnNo: selectedQnNo
        })
      });
      setSelectedQnNo(null);
      await loadQuestions(); // loadQuestions handles setLoading(false)
    } catch {
      setErrorMsg("Error deleting question");
      setLoading(false);
    }
  };

  return (
    <div className="md-page" style={{margin:"15px 30px 30px 15px"}}>
      {/* Show Loading Component when active */}
      {loading && <Loading />}

      <div className="md-main-header">
        Questions in Country = {params.Country}, Strand = {params.Strand},
        SubStrand = {params.SubStrand}, Topic = {params.Topic},
        Lesson = {params.LessonCode}
      </div>

      <div className="md-grid-wrapperT">
        {/* Replicating clsGrid Title logic */}
        <div className="clsGridContainer" id="lst_divScrollableTable" style={{height:'stretch'}}>
            {/* <div className="clsGridTitle">
                Questions in Country = {params.Country}, Strand = {params.Strand}, SubStrand = {params.SubStrand}, Topic = {params.Topic}, Lesson = {params.LessonCode}
            </div> */}
            <table className="clsGridTable">
              <thead className="clsGridHeader">
                <tr>
                  <th className="col-slno">#</th>
                  <th className="col-qnno">QnNo</th>
                  <th className="col-qncatg">QnCatg</th>
                  <th className="col-qnfile">QnFileName</th>
                </tr>
              </thead>
              <tbody>
                {questions.map((q, i) => (
                  <tr
                    key={q.qnno}
                    className={`clsGridRow ${selectedQnNo === q.qnno ? "clsGridSelected" : ""}`}
                    onClick={() => setSelectedQnNo(q.qnno)}
                  >
                    <td className="col-slno">{i + 1}</td>
                    <td className="col-qnno">{q.qnno}</td>
                    <td className="col-qncatg">{q.qncatg}</td>
                    <td className="col-qnfile">{q.qnfilename}</td>
                  </tr>
                ))}
              </tbody>
            </table>
        </div>
      </div>

      <div className="md-footer">
        <table width="100%">
          <tbody>
            <tr>
              <td align="left" style={{ fontSize: "16px" }}>
                {noQnsMsg ? (
                  <span style={{color:'black'}}>{noQnsMsg}</span>
                ) : (
                  <>
                    Questions:&nbsp;
                    <select
                      value={selectedAddFile}
                      onChange={e => setSelectedAddFile(e.target.value)}
                      style={{ maxWidth: "400px" }}
                    >
                      {availableQns.map(q => (
                        <option key={q.filename} value={q.filename}>
                          {q.filename}
                        </option>
                      ))}
                    </select>
                    &nbsp;&nbsp;
                    <button id="buttonT" onClick={handleAdd}>ADD</button>
                  </>
                )}
              </td>
              <td align="right">
                <button id="buttonT" onClick={handleDelete} style={{ marginBottom: "3px" }}>Delete</button>
                &nbsp;&nbsp;
                <button id="buttonT" onClick={() => window.close()}>Exit</button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      {errorMsg && <div className="md-error">{errorMsg}</div>}
    </div>
  );
};

export default EC_AddDeleteQn;
